(function () {
  'use strict';
  function init(root) {
    if (root.dataset.csInitialized === 'true') return;
    root.dataset.csInitialized = 'true';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduced ? 'auto' : 'smooth';
    var list = function (selector, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(selector)); };
    var tabs = list('[data-cs-tab]');
    var stages = list('[data-cs-act]');
    var panels = list('[data-cs-panel]');
    var tracks = {};

    function Track(stage) {
      var el = stage.querySelector('.cs-sc-acts__track');
      var slides = list('.cs-sc-acts__slide', el);
      var count = stage.querySelector('.cs-sc-acts__count');
      var progress = stage.querySelector('.cs-sc-acts__progress');
      var prev = stage.querySelector('[data-cs-prev]');
      var next = stage.querySelector('[data-cs-next]');
      var current = 0;
      var queued = false;
      function index() {
        if (!slides.length) return 0;
        var base = slides[0].offsetLeft;
        var best = 0;
        var distance = Infinity;
        slides.forEach(function (slide, i) {
          var delta = Math.abs(slide.offsetLeft - base - el.scrollLeft);
          if (delta < distance) { distance = delta; best = i; }
        });
        if (el.scrollLeft > 2 && el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) best = slides.length - 1;
        return best;
      }
      function paint() {
        current = index();
        var total = slides.length;
        count.innerHTML = '<b>' + String(total ? current + 1 : 0).padStart(2, '0') + '</b> / ' + String(total).padStart(2, '0');
        var part = el.scrollWidth ? (el.scrollLeft + el.clientWidth) / el.scrollWidth : 1;
        progress.style.setProperty('--cs-progress', Math.min(1, part).toFixed(3));
        prev.disabled = !total || el.scrollLeft <= 2;
        next.disabled = !total || el.scrollLeft >= el.scrollWidth - el.clientWidth - 2;
      }
      function go(i) {
        if (!slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        el.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: behavior });
      }
      el.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; paint(); });
      }, { passive: true });
      prev.addEventListener('click', function () { go(current - 1); });
      next.addEventListener('click', function () { go(current + 1); });
      el.addEventListener('keydown', function (event) {
        if (event.target !== el) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
      });

      var dragging = false;
      var startX = 0;
      var startLeft = 0;
      var moved = 0;
      var startIndex = 0;
      el.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,video')) return;
        dragging = true;
        startX = event.clientX;
        startLeft = el.scrollLeft;
        startIndex = current;
        moved = 0;
        el.classList.add('is-drag');
      });
      window.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        moved = Math.abs(event.clientX - startX);
        el.scrollLeft = startLeft - (event.clientX - startX);
      });
      function finishDrag() {
        if (!dragging) return;
        dragging = false;
        el.classList.remove('is-drag');
        var delta = el.scrollLeft - startLeft;
        var nearest = index();
        if (Math.abs(delta) > 40 && nearest === startIndex) nearest += delta > 0 ? 1 : -1;
        go(nearest);
      }
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
      window.addEventListener('blur', finishDrag);
      el.addEventListener('click', function (event) {
        if (moved > 6) { event.preventDefault(); event.stopPropagation(); moved = 0; }
      }, true);
      window.addEventListener('resize', paint);
      paint();
      return { go: go, paint: paint, slides: slides };
    }

    stages.forEach(function (stage) { tracks[stage.dataset.csAct] = Track(stage); });

    list('[data-cs-video]').forEach(function (card) {
      var frame = card.querySelector('.cs-sc-acts__video-frame');
      var video = card.querySelector('video');
      var button = card.querySelector('.cs-sc-acts__play');
      button.addEventListener('click', function () {
        if (!video.src) { video.src = video.dataset.csSrc; video.load(); }
        video.muted = true;
        video.controls = true;
        var playing = video.play();
        if (playing && playing.then) {
          playing.then(function () { frame.classList.add('is-playing'); }).catch(function () { frame.classList.remove('is-playing'); });
        } else {
          frame.classList.add('is-playing');
        }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.2 && !video.paused) video.pause();
          });
        }, { threshold: 0.2 }).observe(video);
      }
    });

    function selectAct(key, focus) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.csTab === key;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      stages.forEach(function (stage) {
        var active = stage.dataset.csAct === key;
        if (!active) list('video', stage).forEach(function (video) { video.pause(); });
        stage.hidden = !active;
        if (active) { stage.classList.remove('is-shown'); void stage.offsetWidth; stage.classList.add('is-shown'); }
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.csPanel === key;
        panel.hidden = !active;
        if (active) { panel.classList.remove('is-shown'); void panel.offsetWidth; panel.classList.add('is-shown'); }
      });
      requestAnimationFrame(function () { if (tracks[key]) tracks[key].paint(); });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectAct(tab.dataset.csTab, false); });
      tab.addEventListener('keydown', function (event) {
        var delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!delta) return;
        event.preventDefault();
        var next = tabs[(i + delta + tabs.length) % tabs.length];
        selectAct(next.dataset.csTab, true);
      });
    });

    function jumpTo(key, slide) {
      if (!slide || !tracks[key]) return;
      selectAct(key, false);
      requestAnimationFrame(function () {
        tracks[key].go(tracks[key].slides.indexOf(slide));
        if (window.matchMedia('(max-width: 999px)').matches) {
          var stage = stages.filter(function (node) { return node.dataset.csAct === key; })[0];
          var bounds = stage.getBoundingClientRect();
          if (bounds.top < 0 || bounds.bottom > window.innerHeight) stage.scrollIntoView({ behavior: behavior, block: 'center' });
        }
      });
    }
    list('[data-cs-jump-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var slide = root.querySelector('[data-cs-act="first"] [data-cs-step="' + button.dataset.csJumpStep + '"]');
        jumpTo('first', slide);
      });
    });
    list('[data-cs-jump-model]').forEach(function (button) {
      button.addEventListener('click', function () {
        var slide = root.querySelector('[data-cs-act="works"] [data-cs-photo-model="' + button.dataset.csJumpModel + '"]');
        jumpTo('works', slide);
      });
    });

    var reveals = list('.cs-sc-acts__reveal');
    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach(function (node) { node.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      reveals.forEach(function (node) { revealObserver.observe(node); });
      // 保險（v6p1b 實測：JS 有跑、IO 卻一直沒回呼，整區停在全黑）：
      // 2.4 秒後改用捲動位置判斷，已進入或已捲過畫面的一律顯示；之後每次捲動再檢查。內容最多晚 2.4 秒出現，不會永遠看不到。
      var revealFallback = function () {
        var limit = window.innerHeight || document.documentElement.clientHeight;
        reveals.forEach(function (node) {
          if (!node.classList.contains('is-visible') && node.getBoundingClientRect().top < limit) node.classList.add('is-visible');
        });
      };
      window.setTimeout(function () {
        revealFallback();
        window.addEventListener('scroll', revealFallback, { passive: true });
      }, 2400);
    }
    root.classList.add('is-ready');
    selectAct('works', false);
  }
  function initAll() { document.querySelectorAll('[data-cs-sc-acts]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
